import type { GetAllCertificatesResponse } from "~/api/generated-api";

/**
 * La credencial tal como la devuelve la API. Se deriva del cliente generado en vez de
 * redeclararse a mano porque la copia manual se desincronizó: le faltaban `code`, `type` e
 * `issuedAt`, y el front terminaba mostrando `undefined` en una pantalla que la persona
 * comparte con un empleador. Derivándola, el próximo cambio de contrato rompe en compilación.
 */
export type CertificateType = GetAllCertificatesResponse["data"][number];

/**
 * Los rótulos ("Certificado", "constancia", …) viven en `@repo/shared` junto con el resto de lo
 * que dice una credencial, porque el PDF del servidor usa exactamente los mismos. Se re-exportan
 * acá para no tocar a quien ya los importaba de este archivo.
 */
export { credentialLabel, credentialLabelShort } from "@repo/shared";

/** La página pública donde cualquiera puede verificar esta credencial. */
export const credentialPublicPath = (code: string) => `/certificado/${code}`;
